import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h1-bold",
  "use": "icon-h1-bold-usage",
  "viewBox": "0 0 28 36",
  "content": "<symbol viewBox=\"0 0 28 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h1-bold\">\n<path d=\"M1.82 8.436V27H4.862V18.784H14.274V27H17.316V8.436H14.274V16.184H4.862V8.436H1.82Z\" fill=\"#323232\" />\n<path d=\"M24.176 13.1709C23.744 13.6209 23.204 14.0349 22.556 14.4309C21.908 14.7909 21.296 15.0429 20.72 15.1869V17.2749C21.908 16.9329 22.88 16.4109 23.654 15.7089V26.0229H25.76V13.1709H24.176Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol